// Description: This file contains the API service for patching  assets from the Autodesk Construction Cloud API.
export const PatchAssets = async ({selectedProjectId, assets, accessToken}) => {



    const requestHeaders = new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
    });


    const request = new Request(`https://developer.api.autodesk.com/bim360/assets/v2/projects/${selectedProjectId}/assets:batch-patch`, {
        method: 'PATCH',
        headers: requestHeaders,
        body: JSON.stringify(assets)

    });


    try {
        const response = await fetch(request);


        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status} ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error patching data service:', error);
        throw error;
    }
};
